import {
  type ColumnType,
  type Selectable,
  type Insertable,
  type Updateable,
} from 'kysely'
import { z } from 'zod'

/** Identifier type for public.sensor_label_source_ */
export type SensorLabelSourceId = string & { __brand: 'SensorLabelSourceId' }

/** Represents the table public.sensor_label_source_ */
export default interface SensorLabelSourceTable {
  /** Database type: pg_catalog.text */
  id: ColumnType<SensorLabelSourceId, SensorLabelSourceId, SensorLabelSourceId>

  /** Database type: pg_catalog.text */
  description: ColumnType<string | null, string | null, string | null>

  /** Database type: pg_catalog.timestamptz */
  createdAt: ColumnType<Date, Date | string | undefined, Date | string>
}

export type SensorLabelSource = Selectable<SensorLabelSourceTable>

export type SensorLabelSourceInitializer = Insertable<SensorLabelSourceTable>

export type SensorLabelSourceMutator = Updateable<SensorLabelSourceTable>

export const sensorLabelSourceId =
  z.string() as unknown as z.Schema<SensorLabelSourceId>

export const sensorLabelSource = z.object({
  id: sensorLabelSourceId,
  description: z.string().nullable().optional(),
  createdAt: z.coerce.date(),
}) as unknown as z.Schema<SensorLabelSource>

export const sensorLabelSourceInitializer = z.object({
  id: sensorLabelSourceId,
  description: z.string().optional().nullable(),
  createdAt: z.coerce.date().optional(),
}) as unknown as z.Schema<SensorLabelSourceInitializer>

export const sensorLabelSourceMutator = z.object({
  id: sensorLabelSourceId.optional(),
  description: z.string().optional().nullable(),
  createdAt: z.coerce.date().optional(),
}) as unknown as z.Schema<SensorLabelSourceMutator>
